module.exports = __webpack_public_path__ + "static/media/404-image.1c126320.png";